import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Download({ strokeWidth = '1.25', color = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox='0 0 14 14' {...props}>
      <Path
        d='M10 6L7 9L4 6'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7 1V9'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13 10C13 11.6569 11.8059 13 10.333 13H3.667C2.19406 13 1 11.6569 1 10'
        stroke={color}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Download.propTypes = {
  strokeWidth: PropTypes.string,
  color: PropTypes.string,
}

export default Download
